// Zentrales Wörterbuch DE / EN. Zugriff über useT() aus LocaleContext.
export const DICT = {
  de: {
    meta: {
      title: "Hamm EP GmbH · Blechbearbeitung, Lohnfertigung & Edelstahl-Systemkomponenten für die Bahnindustrie",
      description: "Blechbearbeitung, Faserlaser-Schneiden, CNC-Abkanten und Schweißbaugruppen aus Geldern (NRW). Erfahrener Zulieferer für Sanitärmodule im Schienenfahrzeugbau, Systemkomponenten für Sanitärmodule sowie Hygiene- & Waschraumsysteme aus Edelstahl. Wir arbeiten nach EN 15085, ISO 9001, DIN 6701, ISO 3834-2 und IRIS/ISO 22163.",
      keywords: "Blechbearbeitung Geldern, Lohnfertigung Blech NRW, Zulieferer Bahnindustrie, EN 15085 Schweißbaugruppen, Systemkomponenten Sanitärmodule, Nasszellen Schienenfahrzeuge, Faserlaser Edelstahl, CNC Abkantpresse, Hygienespender Edelstahl, ISO 9001, DIN 6701, IRIS ISO 22163, Edelstahl-Systemkomponenten, B2B Metallverarbeitung",
      ogAlt: "Faserlaser-Schneidkopf der Hamm EP GmbH mit Funkenflug bei der Blechbearbeitung von Edelstahl",
      seoH1: "Hamm Entwicklung + Produktion GmbH – Blechbearbeitung, Schweißbaugruppen und Edelstahl-Systemkomponenten aus Geldern (NRW) für die Bahnindustrie",
    },
    nav: {
      hygiene: "Hygiene & Mobilität",
      services: "Leistungen",
      standards: "Normen",
      industries: "Branchen",
      machines: "Maschinenpark",
      practice: "Aus der Praxis",
      inquiry: "Anfrage-Portal",
      career: "Karriere",
      cta: "Anfrage starten",
      admin: "Admin",
      langLabel: "Sprache",
    },
    hero: {
      hygieneEyebrow: "Hygiene & Mobilität",
      hygieneTitle1: "Hygiene &",
      hygieneTitle2: "Mobilität.",
      hygieneCopy: "Hygienespender-Systeme aus Edelstahl und präzise Blechbaugruppen für Nasszellen im Schienenfahrzeugbau – als erfahrener Zulieferer für Sanitärmodule.",
      hygieneList: [
        "Hygienespender aus Edelstahl",
        "Baugruppen für Sanitärmodule",
        "Hygienic Design – Robust und leicht zu reinigen",
      ],
      hygieneCta: "Bereich entdecken",
      contractEyebrow: "Lohnfertigung",
      contractTitle1: "PRÄZISION",
      contractTitle2: "IN BLECH.",
      contractCopy: "Blechteile und Schweißbaugruppen für die Industrie – von der Einzelanfertigung bis zur Serie. CAD-Daten hochladen, wir liefern maßgenau.",
      contractList: [
        "Laserschneiden & Abkanten",
        "Qualifizierte Schweißbaugruppen",
        "Einzelteil- & Serienfertigung",
      ],
      contractCta: "Fertigungsanfrage starten",
      contractBadge: "6 kW Laser · ± 0,1 mm · 25 mm Stahl",
    },
    industries: {
      eyebrow: "Referenzbranchen",
      title1: "Zulieferer für die Branchen, ",
      title2: "die höchste Anforderungen stellen.",
      copy: "Von der ersten CAD-Zeichnung bis zur einbaufertigen Baugruppe – wir fertigen für Kunden, denen Präzision, Dokumentation und Termintreue nicht verhandelbar sind.",
      cards: [
        {
          key: "rail",
          title: "Bahnindustrie",
          desc: "Erfahrener Zulieferer für den Schienenfahrzeugbau: Blechkomponenten, Schweißbaugruppen und Sichtteile aus Edelstahl – schwingungsfest, wartungsfreundlich und dokumentiert nach EN 15085 gefertigt.",
          tags: ["Zulieferer Schienenfahrzeugbau", "Blechbaugruppen", "Sichtteile Edelstahl"],
        },
        {
          key: "medical",
          title: "Medizin & Gesundheit",
          desc: "Berührungslose Hygienespender, Wandbeschläge und Sonderanfertigungen aus gebürstetem Edelstahl. Fugenarm hygienisch geschweißt, für Kliniken, Praxen und Reinraum­umgebungen.",
          tags: ["Edelstahl 1.4301", "Hygienic Design", "Reinraum­tauglich"],
        },
        {
          key: "sanitary",
          title: "Sanitär & öffentliche Räume",
          desc: "Robuste Seifen-, Papier- und Sensor-Spender­systeme für stark frequentierte Waschräume in öffentlichen Gebäuden, Bahnhöfen und Verkehrs­knotenpunkten.",
          tags: ["Vandalismussicher", "Berührungslos", "Wand- & Standmodelle"],
        },
      ],
    },
    standards: {
      eyebrow: "Normen & Regelwerke",
      title1: "Wir arbeiten nach den ",
      title2: "einschlägigen Normen der Branche.",
      copy: "Unsere Prozesse und Prüfabläufe orientieren sich an den relevanten nationalen und internationalen Regelwerken der Metallbearbeitung und des Schienenfahrzeugbaus. So stellen wir sicher, dass gelieferte Baugruppen den Anforderungen unserer Kunden aus der Bahnindustrie, Medizintechnik und Sanitärbranche in vollem Umfang entsprechen.",
      note: "Zertifikatsstatus und -kopien senden wir gerne im Rahmen einer konkreten Anfrage zu. Die genannten Normen bilden den Arbeits- und Prüfrahmen unserer Fertigung.",
      cards: [
        { code: "ISO 9001", title: "Qualitäts­management", desc: "Prozessorientierte Fertigung mit lückenloser Rückverfolgbarkeit von Wareneingang bis Auslieferung." },
        { code: "EN 15085-2", title: "Schweißen im Schienen­fahrzeugbau", desc: "Fertigungsklassen CL1–CL4, geführte Schweißfolgen, qualifizierte Schweißer nach EN ISO 9606-1, dokumentierte WPS/WPQR." },
        { code: "DIN 6701", title: "Kleben an Schienen­fahrzeugen", desc: "Klebtechnische Verarbeitung nach den Anforderungen für Bauteile in Schienen­fahrzeugen." },
        { code: "ISO 3834-2", title: "Schmelz­schweiß­qualität", desc: "Umfassende Qualitäts­anforderungen an Schweißkonstruktionen aus Stahl und Edelstahl." },
        { code: "IRIS / ISO 22163", title: "Business Management Bahn", desc: "Ausrichtung der Fertigungs- und Lieferprozesse an den Anforderungen der internationalen Bahnindustrie." },
        { code: "DIN EN ISO 14001", title: "Umwelt­management", desc: "Ressourcenschonende Produktion, sortenreine Trennung und dokumentierte Umwelt­kennzahlen." },
      ],
    },
    services: {
      eyebrow: "Leistungsportfolio",
      title1: "Vier Kernkompetenzen. ",
      title2: "Ein Ansprechpartner.",
      cta: "Anfragen",
      items: [
        { title: "Konstruktion", desc: "3D-Konstruktion in SOLIDWORKS – von der Idee über die fertigungsgerechte Auslegung bis zur produktionsreifen Zeichnung.", specs: ["SOLIDWORKS 3D-CAD", "Fertigungsgerechte Auslegung", "DXF / STEP / PDF"] },
        { title: "Laserschneiden (Faserlaser)", desc: "Konturgenaues Schneiden mit 6-kW-Faserlaser – scharfe Kanten, minimale Wärmeeinflusszone, höchste Wiederholgenauigkeit.", specs: ["Stahl bis 25 mm", "Edelstahl bis 20 mm", "Aluminium bis 15 mm"] },
        { title: "Abkanten & Biegen", desc: "Abkanten auf unseren CNC-Abkantpressen und der klassischen Abkantpresse – winkelgenau, wiederholbar, auch bei komplexen Biegefolgen.", specs: ["CNC 80 t / 2.500 mm", "CNC 50 t / 1.200 mm", "1× klassische Abkantpresse"] },
        { title: "Schweißbaugruppen", desc: "MIG/MAG- und WIG-geschweißte Baugruppen auf Vorrichtungen – maßhaltig, verzugsarm und dokumentiert gefertigt.", specs: ["MIG / MAG / WIG", "Baugruppen < 250 kg", "Vorrichtungsbau inhouse"] },
      ],
    },
    hygieneSection: {
      eyebrow: "Hygiene & Mobilität",
      title1: "Sauberkeit als System. ",
      title2: "Gefertigt aus Edelstahl.",
      copy: "Vom medizinischen Hygienespender bis zur Blechbaugruppe für Sanitärmodule: Unsere Produkte vereinen sterile Oberflächen, langlebige Mechanik und eine dokumentierte Fertigungsqualität, die Vertrauen schafft.",
      cta: "Projekt anfragen",
      cards: [
        { title: "Hygiene- & Waschraumsysteme", desc: "Von berührungslosen Spendersystemen bis hin zu kompletten Edelstahl-Ausstattungen. Robuste, reinigungsfreundliche Komponenten und Gehäuse – konzipiert für höchste Infektionsschutz-Standards in Kliniken, Praxen und öffentlichen Einrichtungen.", tags: ["Edelstahl 1.4301", "Hygienic Design", "Klinik- & Praxisausstattung"] },
        { title: "Systemkomponenten für Sanitärmodule", desc: "Blechkomponenten und Schweißbaugruppen für Nasszellen im Schienenverkehr – wartungsfreundlich konstruiert und für den harten Dauereinsatz nach EN 15085 zertifiziert gefertigt.", tags: ["Schienenfahrzeugbau", "Wartungsfreundlich", "Vandalismussicher"] },
        { title: "Sterile Sonderlösungen", desc: "Individuelle Edelstahl-Konstruktionen für Reinräume und medizinische Bereiche – hygienisch geschweißt, fugenarm und mühelos zu desinfizieren.", tags: ["Reinraumtauglich", "Hygienic Design", "Maßfertigung"] },
      ],
    },
    machines: {
      eyebrow: "Maschinenpark & Spezifikationen",
      title1: "Kapazitäten, ",
      title2: "die Maßstäbe setzen.",
      highlights: [["6 kW", "Faserlaser-Leistung"], ["2.500 mm", "max. Kantlänge"], ["80 t", "Presskraft"], ["48 h", "Express-Zuschnitt"]],
      cols: ["Maschine", "Technologie", "Kapazität", "Hinweise"],
      note: "Alle Angaben Richtwerte. Sonderformate, höhere Stückzahlen und kombinierte Fertigungsschritte prüfen wir gerne individuell – laden Sie einfach Ihre Zeichnung im Anfrage-Portal hoch.",
    },
    gallery: {
      eyebrow: "Projekt-Galerie",
      title1: "Aus der ",
      title2: "Praxis.",
      copy: "Echte Einblicke in gefertigte Produkte – direkt aus unserer Werkhalle.",
      tabs: [["hygiene", "Hygiene & Mobilität"], ["lohnfertigung", "Lohnfertigung"]],
      empty: "Für diesen Bereich sind noch keine Bilder hinterlegt.",
    },
    inquiry: {
      eyebrow: "Anfrage-Portal",
      title1: "Ihre Fertigungsanfrage. ",
      title2: "Direkt in unsere Produktion.",
      copy: "Wählen Sie Bearbeitungsart und Material, laden Sie Ihre CAD-Daten oder Zeichnungen hoch – Sie erhalten schnellstmöglich ein belastbares Angebot.",
      steps: [
        ["01", "Spezifikation wählen", "Bearbeitungsart, Material und Materialstärke auswählen."],
        ["02", "Daten hochladen", "DXF, STEP, IGES oder PDF-Zeichnung sicher übertragen."],
        ["03", "Angebot erhalten", "Technische Rückmeldung und Angebot – meist innerhalb von 24 h."],
      ],
      labels: {
        firma: "Firma *", firmaPh: "Muster GmbH & Co. KG",
        name: "Ansprechpartner *", namePh: "Max Mustermann",
        email: "E-Mail *", emailPh: "einkauf@firma.de",
        phone: "Telefon", phonePh: "+49 …",
        bearbeitung: "Bearbeitungsart *", material: "Material *", staerke: "Materialstärke *",
        lot: "Losgröße / Stückzahl", lotPh: "z. B. 250 Stück",
        message: "Nachricht / technische Hinweise", messagePh: "Oberflächenanforderungen, Toleranzen, gewünschter Liefertermin …",
        cad: "CAD-Daten & Zeichnungen",
        dropzone: "Dateien hierher ziehen oder",
        browse: "durchsuchen",
        dropzoneNote: "DXF · STEP · IGES · DWG · PDF · ZIP — max. 50 MB pro Datei",
        placeholder: "Bitte wählen",
        submit: "Fertigungsanfrage senden", sending: "Wird übermittelt…",
        privacy: "Ihre Daten werden ausschließlich zur Angebotserstellung verwendet und vertraulich behandelt.",
      },
      success: {
        title: "Anfrage eingegangen.",
        body: "Vielen Dank. Ihre Anfrage wurde an unser Vertriebsteam übermittelt.",
        ticket: "Vorgangsnummer",
        again: "Weitere Anfrage stellen",
      },
      options: {
        bearbeitung: ["Laserschneiden", "Abkanten & Biegen", "Schweißbaugruppen", "Konstruktion", "Komplette Baugruppe (Kombination)"],
        material: ["Stahl (S235 / S355)", "Edelstahl (1.4301 / 1.4571)", "Aluminium", "Messing / Kupfer", "Sonstiges / Beratung"],
        staerke: ["0,5 – 2 mm", "2 – 5 mm", "5 – 10 mm", "10 – 20 mm", "20 – 25 mm", "über 25 mm"],
      },
      toastSuccess: "Anfrage erfolgreich übermittelt",
      toastSuccessDesc: "Unser Team meldet sich in der Regel innerhalb von 24 Stunden.",
      toastMissing: "Bitte wählen Sie Bearbeitungsart, Material und Materialstärke aus.",
    },
    footer: {
      tagline: "Ihr Partner für Hygienespender, Blechbaugruppen für Sanitärmodule und präzise Lohnfertigung in Blech – aus dem Herzen des Niederrheins.",
      contact: "Kontakt",
      navigation: "Navigation",
      adminLink: "Admin-Login",
      claim: "Präzision in Blech · Hygiene in Edelstahl",
      copyright: "© 2026 Hamm Entwicklung + Produktion GmbH",
    },
  },
  en: {
    meta: {
      title: "Hamm EP GmbH · Sheet Metal Fabrication, Contract Manufacturing & Stainless Steel System Components",
      description: "Sheet metal fabrication, fiber laser cutting, CNC bending and welded assemblies from Geldern, Germany (NRW). Experienced supplier for sanitary modules in rolling stock, system components for washroom modules, stainless steel hygiene systems. We work to EN 15085, ISO 9001, DIN 6701, ISO 3834-2 and IRIS/ISO 22163.",
      keywords: "sheet metal fabrication Germany, contract manufacturing NRW, rail industry supplier, EN 15085 welded assemblies, system components sanitary modules, rolling stock sub-assemblies, fiber laser stainless steel, CNC press brake, stainless steel hygiene dispenser, ISO 9001, DIN 6701, IRIS ISO 22163, B2B metal processing",
      ogAlt: "Fiber laser cutting head of Hamm EP GmbH with spark stream during stainless steel sheet metal machining",
      seoH1: "Hamm Entwicklung + Produktion GmbH – Sheet Metal Fabrication, Welded Assemblies and Stainless Steel System Components from Geldern (Germany) for the Rail Industry",
    },
    nav: {
      hygiene: "Hygiene & Mobility",
      services: "Services",
      standards: "Standards",
      industries: "Industries",
      machines: "Machinery",
      practice: "Case Gallery",
      inquiry: "Inquiry Portal",
      career: "Careers",
      cta: "Start Inquiry",
      admin: "Admin",
      langLabel: "Language",
    },
    hero: {
      hygieneEyebrow: "Hygiene & Mobility",
      hygieneTitle1: "Hygiene &",
      hygieneTitle2: "Mobility.",
      hygieneCopy: "Hygiene dispenser systems in stainless steel and precision sheet metal sub-assemblies for sanitary modules in rolling stock – as an experienced supplier for sanitary modules.",
      hygieneList: [
        "Stainless steel hygiene dispensers",
        "Sub-assemblies for sanitary modules",
        "Hygienic design – robust and easy to clean",
      ],
      hygieneCta: "Explore this area",
      contractEyebrow: "Contract Manufacturing",
      contractTitle1: "PRECISION",
      contractTitle2: "IN METAL.",
      contractCopy: "Sheet metal parts and welded assemblies for industry – from one-off prototypes to serial production. Upload your CAD data, we deliver to spec.",
      contractList: [
        "Laser cutting & bending",
        "Qualified welded assemblies",
        "Prototype & serial production",
      ],
      contractCta: "Start manufacturing inquiry",
      contractBadge: "6 kW laser · ± 0.1 mm · 25 mm steel",
    },
    industries: {
      eyebrow: "Reference Industries",
      title1: "Supplier for the industries ",
      title2: "that demand the most.",
      copy: "From the first CAD drawing to a ready-to-install assembly – we produce for customers who cannot compromise on precision, documentation and on-time delivery.",
      cards: [
        {
          key: "rail",
          title: "Rail Industry",
          desc: "Experienced supplier to the rail industry: sheet metal components, welded sub-assemblies and stainless steel visible parts – vibration-resistant, service-friendly and documented to EN 15085.",
          tags: ["Rail industry supplier", "Welded sub-assemblies", "Stainless visible parts"],
        },
        {
          key: "medical",
          title: "Medical & Healthcare",
          desc: "Touch-free hygiene dispensers, wall fittings and custom fabrications in brushed stainless steel. Hygienically welded with minimal seams, for clinics, practices and cleanroom environments.",
          tags: ["Stainless 1.4301", "Hygienic design", "Cleanroom-capable"],
        },
        {
          key: "sanitary",
          title: "Sanitary & Public Spaces",
          desc: "Rugged soap, paper and sensor dispenser systems for high-traffic washrooms in public buildings, railway stations and transport hubs.",
          tags: ["Vandal-resistant", "Touch-free", "Wall- & floor-standing"],
        },
      ],
    },
    standards: {
      eyebrow: "Standards & Codes",
      title1: "We work to the ",
      title2: "relevant standards of the industry.",
      copy: "Our processes and inspection routines are aligned with the relevant national and international standards for metalworking and rolling stock manufacturing. This ensures that delivered assemblies fully meet the expectations of our customers in the rail industry, medical technology and sanitary sectors.",
      note: "Current certificate status and copies are shared on request as part of a concrete inquiry. The standards listed above define the framework in which we manufacture and inspect.",
      cards: [
        { code: "ISO 9001", title: "Quality management", desc: "Process-driven manufacturing with full traceability from goods-in through to delivery." },
        { code: "EN 15085-2", title: "Welding of rail vehicles", desc: "Certification classes CL1–CL4, controlled welding sequences, welders qualified to EN ISO 9606-1, documented WPS/WPQR." },
        { code: "DIN 6701", title: "Bonding on rail vehicles", desc: "Adhesive bonding technology in line with the requirements for components in rail vehicles." },
        { code: "ISO 3834-2", title: "Fusion welding quality", desc: "Comprehensive quality requirements for welded fabrications in steel and stainless steel." },
        { code: "IRIS / ISO 22163", title: "Rail business management", desc: "Manufacturing and delivery processes aligned with the requirements of the international rail industry." },
        { code: "DIN EN ISO 14001", title: "Environmental management", desc: "Resource-efficient production, waste separation by fraction and documented environmental KPIs." },
      ],
    },
    services: {
      eyebrow: "Service portfolio",
      title1: "Four core competencies. ",
      title2: "One point of contact.",
      cta: "Inquire",
      items: [
        { title: "Engineering", desc: "3D design in SOLIDWORKS – from concept and manufacturing-friendly design to production-ready drawings.", specs: ["SOLIDWORKS 3D-CAD", "Design for manufacturing", "DXF / STEP / PDF"] },
        { title: "Laser cutting (fiber laser)", desc: "Contour-accurate cutting on a 6 kW fiber laser – sharp edges, minimal heat-affected zone, highest repeatability.", specs: ["Steel up to 25 mm", "Stainless up to 20 mm", "Aluminium up to 15 mm"] },
        { title: "Bending & forming", desc: "Bending on CNC press brakes and a classic press brake – accurate, repeatable, even with complex bend sequences.", specs: ["CNC 80 t / 2,500 mm", "CNC 50 t / 1,200 mm", "1× classic press brake"] },
        { title: "Welded assemblies", desc: "MIG/MAG and TIG welded assemblies on fixtures – dimensionally accurate, low-distortion and documented.", specs: ["MIG / MAG / TIG", "Assemblies < 250 kg", "In-house jig design"] },
      ],
    },
    hygieneSection: {
      eyebrow: "Hygiene & Mobility",
      title1: "Cleanliness by system. ",
      title2: "Built from stainless steel.",
      copy: "From medical hygiene dispensers to sheet metal sub-assemblies for sanitary modules: our products combine sterile surfaces, durable mechanics and documented manufacturing quality that builds trust.",
      cta: "Request a project",
      cards: [
        { title: "Hygiene & washroom systems", desc: "From touch-free dispenser systems to complete stainless steel washroom fittings. Robust, easy-to-clean components and housings – engineered for the highest infection-control standards in clinics, practices and public facilities.", tags: ["Stainless 1.4301", "Hygienic Design", "Clinic & practice equipment"] },
        { title: "System components for sanitary modules", desc: "Sheet metal components and welded sub-assemblies for sanitary modules in rail transport – service-friendly by design and manufactured certified to EN 15085 for continuous heavy-duty operation.", tags: ["Rail industry", "Service-friendly", "Vandal-resistant"] },
        { title: "Sterile custom solutions", desc: "Bespoke stainless steel fabrications for cleanrooms and medical areas – hygienically welded, low-seam and easy to disinfect.", tags: ["Cleanroom-capable", "Hygienic design", "Made to measure"] },
      ],
    },
    machines: {
      eyebrow: "Machinery & specifications",
      title1: "Capacity ",
      title2: "that sets benchmarks.",
      highlights: [["6 kW", "fiber laser power"], ["2,500 mm", "max. bending length"], ["80 t", "press force"], ["48 h", "express cutting"]],
      cols: ["Machine", "Technology", "Capacity", "Notes"],
      note: "All figures are indicative. Special formats, higher quantities and combined manufacturing steps are reviewed individually – simply upload your drawing in the inquiry portal.",
    },
    gallery: {
      eyebrow: "Project gallery",
      title1: "From the ",
      title2: "shop floor.",
      copy: "Real insights into finished products – straight from our workshop.",
      tabs: [["hygiene", "Hygiene & Mobility"], ["lohnfertigung", "Contract manufacturing"]],
      empty: "No images have been added to this area yet.",
    },
    inquiry: {
      eyebrow: "Inquiry portal",
      title1: "Your manufacturing inquiry. ",
      title2: "Straight to our production.",
      copy: "Select processing type and material, upload your CAD data or drawings – you will receive a solid quote as fast as possible.",
      steps: [
        ["01", "Choose specification", "Select processing type, material and material thickness."],
        ["02", "Upload data", "Securely transfer DXF, STEP, IGES or PDF drawings."],
        ["03", "Receive quote", "Technical feedback and quote – usually within 24 h."],
      ],
      labels: {
        firma: "Company *", firmaPh: "Sample Ltd.",
        name: "Contact person *", namePh: "Jane Doe",
        email: "E-mail *", emailPh: "purchasing@company.com",
        phone: "Phone", phonePh: "+49 …",
        bearbeitung: "Processing type *", material: "Material *", staerke: "Material thickness *",
        lot: "Lot size / quantity", lotPh: "e.g. 250 pcs",
        message: "Message / technical notes", messagePh: "Surface requirements, tolerances, target delivery date …",
        cad: "CAD data & drawings",
        dropzone: "Drop files here or",
        browse: "browse",
        dropzoneNote: "DXF · STEP · IGES · DWG · PDF · ZIP — max. 50 MB per file",
        placeholder: "Please select",
        submit: "Send manufacturing inquiry", sending: "Sending…",
        privacy: "Your data will be used solely to prepare a quote and treated strictly confidential.",
      },
      success: {
        title: "Inquiry received.",
        body: "Thank you. Your inquiry has been forwarded to our sales team.",
        ticket: "Ticket number",
        again: "Submit another inquiry",
      },
      options: {
        bearbeitung: ["Laser cutting", "Bending & forming", "Welded assemblies", "Engineering", "Complete assembly (combined)"],
        material: ["Steel (S235 / S355)", "Stainless (1.4301 / 1.4571)", "Aluminium", "Brass / copper", "Other / consultation"],
        staerke: ["0.5 – 2 mm", "2 – 5 mm", "5 – 10 mm", "10 – 20 mm", "20 – 25 mm", "over 25 mm"],
      },
      toastSuccess: "Inquiry successfully submitted",
      toastSuccessDesc: "Our team usually responds within 24 hours.",
      toastMissing: "Please choose processing type, material and material thickness.",
    },
    footer: {
      tagline: "Your partner for hygiene dispensers, sheet metal sub-assemblies for sanitary modules and precision contract manufacturing – from the heart of the Lower Rhine region, Germany.",
      contact: "Contact",
      navigation: "Navigation",
      adminLink: "Admin login",
      claim: "Precision in metal · Hygiene in stainless steel",
      copyright: "© 2026 Hamm Entwicklung + Produktion GmbH",
    },
  },
};

export const get = (locale, path) => {
  const parts = path.split(".");
  let cur = DICT[locale] || DICT.de;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
};
